var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('section',[_c('div',[_c('p',{staticClass:"page-body",domProps:{"innerHTML":_vm._s(_vm.extractIframe(_vm.page.body))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }